import styled from "styled-components";

export const PageLocationTitle = styled.h1`
  color: rgb(25, 31, 40);
  text-transform: uppercase;
  font-size: 24px;
  width: 100%;
  font-weight: 600;
  font-family: "Barlow Condensed", sans-serif;
  letter-spacing: 0.5px;
`;

export const SummaryCard = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 2px 8px rgba(26, 34, 82, 0.08);
  border: 1px solid rgba(26, 34, 82, 0.06);
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0px 4px 16px rgba(26, 34, 82, 0.12);
  }
`;

export const SummaryValue = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: #1a2252;
  font-family: "Barlow Condensed", sans-serif;
`;

export const SummaryLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #6b7490;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-top: 4px;
`;

export const RankBadge = styled.span<{ rank: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: ${({ rank }) =>
    rank === 1
      ? "linear-gradient(135deg, #f59e0b, #d97706)"
      : rank === 2
      ? "linear-gradient(135deg, #9098b0, #6b7490)"
      : rank === 3
      ? "linear-gradient(135deg, #cd7f32, #a0522d)"
      : "#dde1eb"};
  color: ${({ rank }) => (rank > 3 ? "#4e5672" : "#fff")};
`;

export const AthleteChip = styled.span`
  display: inline-block;
  background: #eef0f5;
  color: #353d58;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 12px;
  margin: 2px 4px 2px 0;
  white-space: nowrap;
`;

export const ExpandRow = styled.tr<{ $expanded: boolean }>`
  cursor: pointer;
  transition: background-color 0.15s;
  background-color: ${({ $expanded }) =>
    $expanded ? "#f0f2f8" : "transparent"};

  &:hover {
    background-color: #f0f2f8;
  }
`;

export const AthletesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 12px 0;
`;
